module.exports = __webpack_public_path__ + "img/report.d92a7381.svg";